import * as React from "react";
import styled from "styled-components/macro";
import {useTranslation} from "react-i18next";
import {i18n} from "../translations/i18n";

import {IconButton as MuiIconButton, Menu, MenuItem, Tooltip,} from "@material-ui/core";
import {Languages} from "../constants/languages";
import {removeSuffix} from "../utils/functions";

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

const Flag = styled.img`
  border-radius: 50%;
  width: 22px;
  height: 22px;
`;

const menuStyle = {
  list: {
    style: {
      paddingTop: 3,
      paddingBottom: 3,
      backgroundColor: '#000000',
      borderRadius: 8,
      fontSize: 20
    }
  },
  paper: {
    style: {
      transform: 'translateX(5%) translateY(18%)'
    }
  }
}

export const FLAGS: any = {
  [Languages.English]: <Flag src="/static/img/flags/gb.png" alt={Languages.English} />,
  [Languages.Swedish]: <Flag src="/static/img/flags/se.png" alt={Languages.Swedish} />,
  [Languages.Danish]: <Flag src="/static/img/flags/dk.png" alt={Languages.Danish} />,
  [Languages.German]: <Flag src="/static/img/flags/de.png" alt={Languages.German} />,
  [Languages.Spanish]: <Flag src="/static/img/flags/es.png" alt={Languages.Spanish} />,
  [Languages.French]: <Flag src="/static/img/flags/fr.png" alt={Languages.French} />,
  [Languages.Norwegian]: <Flag src="/static/img/flags/no.png" alt={Languages.Norwegian} />,
  [Languages.Portuguese]: <Flag src="/static/img/flags/pt.png" alt={Languages.Portuguese} />,
  [Languages.Ukrainian]: <Flag src="/static/img/flags/ua.png" alt={Languages.Ukrainian} />
}

/* 
  NOTE! When adding a new language please check first if the language has LCID codes: https://wiki.freepascal.org/Language_Codes
  If it has, include them in the conditional check below like we do for Swedish!
  This is because we have the browser language detector and it will first detect the LCID code.
*/

function LanguagesDropdown() {
  const [anchorMenu, setAnchorMenu] = React.useState<any>(null);

  const { t } = useTranslation();

  const toggleMenu = (event: React.SyntheticEvent) => {    
    setAnchorMenu(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorMenu(null);
  };

  const handleChange = (lang: string) => {
    console.log(lang)
    i18n.changeLanguage(lang, (err) => {
      if (err) return console.log('something went wrong loading language', err);
    });
    setAnchorMenu(null);
  };

  const namesLanguages: { [key: string]: any } = {
    [Languages.English]: t("LanguagesDropdown_English"),
    [Languages.Swedish]: t("LanguagesDropdown_Swedish"),
    [Languages.Danish]: t("LanguagesDropdown_Danish"),
    [Languages.German]: t("LanguagesDropdown_German"),
    [Languages.Spanish]: t('LanguagesDropdown_Spanish'),
    [Languages.French]: t("LanguagesDropdown_French"),
    [Languages.Norwegian]: t("LanguagesDropdown_Norwegian"),
    [Languages.Portuguese]: t("LanguagesDropdown_Portuguese"),
    [Languages.Ukrainian]: t("LanguagesDropdown_Ukrainian"),
  }

  const getFlag = () => {
    switch (removeSuffix(i18n.language)) {
      case Languages.English:
        return <Flag src="/static/img/flags/gb.png" alt={namesLanguages[Languages.English]} />
      case Languages.Swedish || Languages.SwedishSE:
        return <Flag src="/static/img/flags/se.png" alt={namesLanguages[Languages.Swedish]} />
      case Languages.Danish:
        return <Flag src="/static/img/flags/dk.png" alt={namesLanguages[Languages.Danish]} />
      case Languages.German:
        return <Flag src="/static/img/flags/de.png" alt={namesLanguages[Languages.German]} />
      case Languages.Spanish:
        return <Flag src="/static/img/flags/es.png" alt={namesLanguages[Languages.Spanish]} />
      case Languages.French:
        return <Flag src="/static/img/flags/fr.png" alt={namesLanguages[Languages.French]} />
      case Languages.Norwegian:
        return <Flag src="/static/img/flags/no.png" alt={namesLanguages[Languages.Norwegian]} />
      case Languages.Portuguese:
        return <Flag src="/static/img/flags/pt.png" alt={namesLanguages[Languages.Portuguese]} />
      case Languages.Ukrainian:
        return <Flag src="/static/img/flags/ua.png" alt={namesLanguages[Languages.Ukrainian]} />
      default:
        return <Flag src="/static/img/flags/gb.png" alt={namesLanguages.en} />
    }
  }

  const getMenuList = () => {
    return Object.keys(namesLanguages).map((name, index) => {
      return <MenuItem
        key={index}
        onClick={() => handleChange(name)} selected={removeSuffix(i18n.language) === name}>
          {namesLanguages[name]}
      </MenuItem>
    })
  }

  return (
    <React.Fragment>
      <Tooltip title={String(t("LanguagesDropdown_Languages"))}>
        <IconButton
          aria-owns={Boolean(anchorMenu) ? "menu-appbar" : undefined}
          aria-haspopup="true"
          onClick={toggleMenu}
          color="inherit"
        >
          {getFlag()}
        </IconButton>
      </Tooltip>
      <Menu
        id="menu-appbar"
        anchorEl={anchorMenu}
        open={Boolean(anchorMenu)}
        onClose={closeMenu}
        PaperProps={menuStyle.paper}
        MenuListProps={menuStyle.list}
      >
        {getMenuList()}
      </Menu>
    </React.Fragment>
  );
}

export default LanguagesDropdown;